// src/routes/TermsOfService.jsx
import ContentPage from "@/components/content/ContentPage";

const TermsOfService = () => <ContentPage docKey="terms" placeholder />;

export default TermsOfService;
